var _a;
import { TIERS } from '../models/careerPath';
export var CAREER_TRACK_COLORS = {
    'Semi-skilled': 'Colors/Base/Black',
    'Trades/Technical': 'Colors/Foreground/fg-success-secondary',
    'Middle-Tier': 'Error/400',
    'Upper-Tier': 'Warning/400',
    'Top-Tier': 'Colors/Background/bg-brand-solid',
    Entrepreneurship: 'Colors/Background/bg-brand-solid',
    Unskilled: 'Gray/500',
};
export var TIER_KEY_TO_COLOR = {
    SEMISKILLED: CAREER_TRACK_COLORS['Semi-skilled'],
    TRADE: CAREER_TRACK_COLORS['Trades/Technical'],
    MID: CAREER_TRACK_COLORS['Middle-Tier'],
    UPPER: CAREER_TRACK_COLORS['Upper-Tier'],
    TOP: CAREER_TRACK_COLORS['Top-Tier'],
    ENTREPRENEURSHIP: CAREER_TRACK_COLORS['Entrepreneurship'],
};
export var TIER_TO_COLOR = (_a = {},
    _a[TIERS.SEMISKILLED] = CAREER_TRACK_COLORS['Semi-skilled'],
    _a[TIERS.TRADE] = CAREER_TRACK_COLORS['Trades/Technical'],
    _a[TIERS.MID] = CAREER_TRACK_COLORS['Middle-Tier'],
    _a[TIERS.UPPER] = CAREER_TRACK_COLORS['Upper-Tier'],
    _a[TIERS.TOP] = CAREER_TRACK_COLORS['Top-Tier'],
    _a[TIERS.ENTREPRENEURSHIP] = CAREER_TRACK_COLORS['Entrepreneurship'],
    _a);
